(() => {
	angular.module('main').directive('companyNavbar', companyNavbar);

	companyNavbar.$inject = [];

	function companyNavbar() {
		return {
			restrict: 'E',
			replace: true,
			scope: true,
			template: require('./companyNavbar.component.html'),
			link() {}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/navigation/company-navbar/companyNavbar.component.js